module.exports = __webpack_public_path__ + "img/plus.b37e3783.svg";